import React from "react";
import { useTranslation } from "react-i18next";
import fpvImg from "../../Assets/ServiceImg/fpv.webp"; // Imagen del servicio
import fpvmenubg from "../../Assets/ServiceImg/fpv-bg.webp"; // Imagen de fondo de las preguntas
import fpvquestionsbg from "../../Assets/ServiceImg/fpv-qbg.webp"; // Imagen de fondo de las preguntas
import Contact from "../Home/Contact";
import ServiceInfo from "./ServiceInfo";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import Seoimg from "../../Assets/ServiceImg/fpv-qbg.webp";

const FPV = () => {
   const { t } = useTranslation();

      const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   const seoTranslations = {
      es: {
         title: "Grabación con Drones FPV | Joan Company",
         description:
            "Filmación FPV de alta velocidad para vehículos, marcas y deportes de acción. Presupuesto sin compromiso.",
         keywords:
            "grabación fpv, drones fpv, servicios con drones, grabación con drones, filmación con drones, fotografía aérea, videografía aérea",
         canonical: "https://www.joancompany.es/grabacion-fpv",
      },
      en: {
         title: "FPV Drone Recording | Joan Company",
         description:
            "High-speed FPV recording for vehicles, brands and action sports. Budget without compromise.",
         keywords:
            "fpv recording, fpv drones, drone services, drone recording, drone filming, aerial photography, aerial videography",
         canonical: "https://www.joancompany.es/en/grabacion-fpv",
      },
   };

    return (
       <div className="service-container">
          <Helmet>
             <title key="title">{seoTranslations[selectedLanguage].title}</title>
             <meta
                key="description"
                name="description"
                content={seoTranslations[selectedLanguage].description}
             />
             <meta
                key="keywords"
                name="keywords"
                content={seoTranslations[selectedLanguage].keywords}
             />
             <link
                rel="canonical"
                href={seoTranslations[selectedLanguage].canonical}
             />
             <meta property="og:image" content={Seoimg} />
             <meta
                property="og:title"
                content={seoTranslations[selectedLanguage].title}
             />
             <meta
                property="og:description"
                content={seoTranslations[selectedLanguage].description}
             />
             <link rel="image_src" href={Seoimg} />
             <link
                rel="alternate"
                href="https://www.joancompany.es/grabacion-fpv"
                hreflang="es"
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/en/grabacion-fpv"
                hreflang="en"
             />
               <html lang={selectedLanguage} />
          </Helmet>
          <ServiceInfo
             title={t("fpv")}
             image={fpvmenubg}
             subtitle={t("fpv_desc")}
             description={t("fpv_desc")}
          />
          <Card
             className="quote-card-view"
             id="service-info-card"
          >
             <Card.Body>
                <div className="service-info-content-container">
                   <div className="service-info-content">
                      <h3>{t("fpv_subtitle")}</h3>
                      <div
                         dangerouslySetInnerHTML={{
                            __html: t("fpv_info"),
                         }}
                      />
                   </div>
                   <div className="service-info-image">
                      <img
                         src={fpvImg}
                         alt={t("fpv")}
                         title={t("fpv")}
                         loading="lazy"
                      />
                   </div>
                </div>
             </Card.Body>
          </Card>
          <div
             className="service-questions"
             style={{ backgroundImage: `url(${fpvquestionsbg})` }}
          >
             <div className="service-questions-container">
                <div
                   dangerouslySetInnerHTML={{
                      __html: t("fpv_questions"),
                   }}
                />
             </div>
          </div>
          <Contact />
       </div>
    );
};

export default FPV;
